import { Accordions } from "@/ui/Accordions";
import cn from "classnames";
import { Col, Container, Row } from "react-bootstrap";

import { Buttons } from "@/ui/Buttons";
import { Tip } from "@/ui/Tip";
import classes from "./styles.module.scss";

export default function ({
  className = "py-5",
  title,
  items,
  buttons,
  EditableText,
  theme = "light",
  Tips = false,
}) {
  return (
    <div
      id={Tips === true ? "Tips" : ""}
      className={cn(className, classes.ContentAccordions)}
      data-bs-theme={theme}
    >
      <Container>
        <Row>
          {title && (
            <Col xs={12} md={2}>
              <EditableText path="title" tag="h2" className="mb-4">
                <span dangerouslySetInnerHTML={{ __html: title }} />
              </EditableText>
            </Col>
          )}
          <Col className="mb-4">
            <Accordions
              className="flex-grow-1"
              items={items.map(({ title, content }) => {
                const [description, tip] = content.split("<tip>");

                if (tip) {
                  return {
                    name: title,
                    description: (
                      <>
                        <div dangerouslySetInnerHTML={{ __html: description }} />
                        <Tip theme="light" className="bg-white text-dark" text={tip} />
                      </>
                    ),
                  };
                }

                return { name: title, description };
              })}
            />
          </Col>
          {buttons && <Buttons buttons={buttons} />}
        </Row>
      </Container>
    </div>
  );
}
